<section class="season-detail-page">
  <app-admin-page-header
    [title]="season ? 'Temporada: ' + season.name : 'Temporada'"
    subtitle="Gestão completa da season, passe, clone e entidades relacionadas.">
    <div header-actions>
      <button class="admin-btn admin-btn--primary" [routerLink]="['/dashboard/temporadas', seasonId, 'ranking']">
        Ver ranking
      </button>
      <button class="admin-btn admin-btn--secondary" [routerLink]="['/dashboard/temporadas']">
        Voltar
      </button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>
  <div class="admin-feedback admin-feedback--success" *ngIf="feedbackSuccess">
    {{ feedbackSuccess }}
  </div>

  <div class="admin-surface block">
    <h3>Temporada</h3>
    <div class="grid">
      <label>
        <span>Nome</span>
        <input class="admin-input" [(ngModel)]="seasonName" />
      </label>
      <label>
        <span>Início</span>
        <input class="admin-input" type="datetime-local" [(ngModel)]="seasonStartLocal" />
      </label>
      <label>
        <span>Fim</span>
        <input class="admin-input" type="datetime-local" [(ngModel)]="seasonEndLocal" />
      </label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="updateSeason()">Salvar temporada</button>
    </div>
  </div>

  <div class="admin-surface block">
    <h3>Passe de batalha</h3>
    <div class="grid">
      <label>
        <span>Nome</span>
        <input class="admin-input" [(ngModel)]="passName" />
      </label>
      <label>
        <span>Preço em gemas</span>
        <input class="admin-input" type="number" [(ngModel)]="passPriceGems" />
      </label>
      <label>
        <span>Preço em moedas</span>
        <input class="admin-input" type="number" [(ngModel)]="passPriceCoins" />
      </label>
    </div>
    <label>
      <span>Descrição</span>
      <textarea class="admin-input" rows="3" [(ngModel)]="passDescription"></textarea>
    </label>
    <div class="grid">
      <label>
        <span>Imagem decorador nível</span>
        <input type="file" accept="image/*" (change)="onFileSelected($event, 'decorator')" />
      </label>
      <label>
        <span>Imagem de fundo</span>
        <input type="file" accept="image/*" (change)="onFileSelected($event, 'background')" />
      </label>
      <label>
        <span>Preview rewards</span>
        <input type="file" accept="image/*" (change)="onFileSelected($event, 'preview')" />
      </label>
      <label>
        <span>Imagem modal compra</span>
        <input type="file" accept="image/*" (change)="onFileSelected($event, 'modal')" />
      </label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="updateBattlePass()">Salvar passe</button>
    </div>
  </div>

  <div class="admin-surface block">
    <h3>Clone de template</h3>
    <div class="grid">
      <label>
        <span>Season template</span>
        <select class="admin-input" [(ngModel)]="cloneTemplateSeasonId">
          <option [ngValue]="undefined">Selecione</option>
          <option *ngFor="let template of templates" [ngValue]="template.id">
            #{{ template.id }} - {{ template.name }}
          </option>
        </select>
      </label>
    </div>
    <div class="checks">
      <label><input type="checkbox" [(ngModel)]="cloneMissions" /> Clonar missões</label>
      <label><input type="checkbox" [(ngModel)]="cloneLevels" /> Clonar níveis</label>
      <label><input type="checkbox" [(ngModel)]="cloneRewards" /> Clonar recompensas</label>
      <label><input type="checkbox" [(ngModel)]="replaceExisting" /> Substituir dados atuais</label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--secondary" (click)="cloneFromTemplate()">
        Executar clone
      </button>
    </div>
  </div>

  <div class="admin-surface block">
    <h3>Season Rewards (Top posições)</h3>
    <div class="grid grid--four">
      <label>
        <span>Posição</span>
        <input class="admin-input" type="number" [(ngModel)]="rewardForm.position" />
      </label>
      <label class="span-2">
        <span>Recompensa</span>
        <input class="admin-input" [(ngModel)]="rewardForm.reward" />
      </label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="saveSeasonReward()">Salvar reward</button>
      <button class="admin-btn admin-btn--secondary" (click)="resetSeasonRewardForm()">Limpar</button>
    </div>
    <table class="admin-table">
      <thead>
        <tr>
          <th>Posição</th>
          <th>Recompensa</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let reward of seasonRewards">
          <td>{{ reward.position }}</td>
          <td>{{ reward.reward }}</td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="editSeasonReward(reward)">Editar</button>
            <button class="admin-btn admin-btn--danger" (click)="deleteSeasonReward(reward.id)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="admin-surface block">
    <h3>Níveis do passe</h3>
    <div class="grid grid--four">
      <label>
        <span>Nível</span>
        <input class="admin-input" type="number" [(ngModel)]="levelForm.level" />
      </label>
      <label>
        <span>XP para liberar</span>
        <input class="admin-input" type="number" [(ngModel)]="levelForm.xp_to_unlock" />
      </label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="saveLevel()">Salvar nível</button>
      <button class="admin-btn admin-btn--secondary" (click)="resetLevelForm()">Limpar</button>
    </div>
    <table class="admin-table">
      <thead>
        <tr>
          <th>Nível</th>
          <th>XP</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let level of levels">
          <td>{{ level.level }}</td>
          <td>{{ level.xp_to_unlock }}</td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="editLevel(level)">Editar</button>
            <button class="admin-btn admin-btn--danger" (click)="deleteLevel(level.id)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="admin-surface block">
    <h3>Missões do passe</h3>
    <div class="grid">
      <label>
        <span>Categoria</span>
        <select class="admin-input" [(ngModel)]="missionForm.category">
          <option *ngFor="let option of missionCategories" [value]="option">{{ option }}</option>
        </select>
      </label>
      <label>
        <span>Nome</span>
        <input class="admin-input" [(ngModel)]="missionForm.name" />
      </label>
      <label>
        <span>Ativação</span>
        <input class="admin-input" type="datetime-local" [(ngModel)]="missionActivationLocal" />
      </label>
      <label>
        <span>XP reward</span>
        <input class="admin-input" type="number" [(ngModel)]="missionForm.xp_reward" />
      </label>
      <label>
        <span>Target</span>
        <input class="admin-input" type="number" [(ngModel)]="missionForm.target_value" />
      </label>
    </div>
    <label>
      <span>Descrição</span>
      <textarea class="admin-input" rows="2" [(ngModel)]="missionForm.description"></textarea>
    </label>
    <label>
      <span>Query (opcional)</span>
      <textarea class="admin-input" rows="2" [(ngModel)]="missionForm.query"></textarea>
    </label>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="saveMission()">Salvar missão</button>
      <button class="admin-btn admin-btn--secondary" (click)="resetMissionForm()">Limpar</button>
    </div>
    <table class="admin-table">
      <thead>
        <tr>
          <th>Categoria</th>
          <th>Nome</th>
          <th>Ativação</th>
          <th>Target</th>
          <th>XP</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let mission of missions">
          <td>{{ mission.category }}</td>
          <td>{{ mission.name }}</td>
          <td>{{ mission.activation_date | date : 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ mission.target_value }}</td>
          <td>{{ mission.xp_reward }}</td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="editMission(mission)">Editar</button>
            <button class="admin-btn admin-btn--danger" (click)="deleteMission(mission.id)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="admin-surface block">
    <h3>Recompensas do passe</h3>
    <div class="grid">
      <label>
        <span>Nível</span>
        <input class="admin-input" type="number" [(ngModel)]="passRewardForm.level" />
      </label>
      <label>
        <span>Categoria</span>
        <select class="admin-input" [(ngModel)]="passRewardForm.category">
          <option value="FREE">FREE</option>
          <option value="PAID">PAID</option>
        </select>
      </label>
      <label>
        <span>Tipo</span>
        <select class="admin-input" [(ngModel)]="passRewardForm.reward_type">
          <option value="COIN">COIN</option>
          <option value="GEM">GEM</option>
          <option value="HERO">HERO</option>
        </select>
      </label>
      <label>
        <span>Amount</span>
        <input class="admin-input" type="number" [(ngModel)]="passRewardForm.reward_amount" />
      </label>
      <label>
        <span>Hero ID (quando HERO)</span>
        <input class="admin-input" type="number" [(ngModel)]="passRewardForm.hero_id" />
      </label>
    </div>
    <div class="actions">
      <button class="admin-btn admin-btn--primary" (click)="savePassReward()">Salvar recompensa</button>
      <button class="admin-btn admin-btn--secondary" (click)="resetPassRewardForm()">Limpar</button>
    </div>
    <table class="admin-table">
      <thead>
        <tr>
          <th>Nível</th>
          <th>Categoria</th>
          <th>Tipo</th>
          <th>Amount</th>
          <th>Hero</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let reward of passRewards">
          <td>{{ reward.level }}</td>
          <td>{{ reward.category }}</td>
          <td>{{ reward.reward_type }}</td>
          <td>{{ reward.reward_amount }}</td>
          <td>{{ reward.hero?.name || '-' }}</td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="editPassReward(reward)">Editar</button>
            <button class="admin-btn admin-btn--danger" (click)="deletePassReward(reward.id)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
